import GooglePayButton from "@google-pay/button-react";
import { LanguageCode } from "../../common/Conf";
import { i18n } from "../../lang/i18n";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";

interface Props
{
    onPaymentOk: (paymentRequest: any) => void,
    onClick?: () => void,
    totalPrice: number
}

export default function PayWithGoogle(props: Props)
{
    const googlePay = useAppSelector((state) => state.appData.gp)
    const navigate = useNavigate();

    if(!googlePay) return <></>
    return (<div className="text-center" >
        <GooglePayButton
            environment={googlePay.environment}
            buttonLocale={LanguageCode}
            buttonSizeMode="fill"
            paymentRequest={{
                apiVersion: 2,
                apiVersionMinor: 0,
                allowedPaymentMethods: [
                    {
                        type: 'CARD',
                        parameters: {
                            allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                            allowedCardNetworks: ['MASTERCARD', 'VISA'],
                        },
                        tokenizationSpecification: {
                            type: 'PAYMENT_GATEWAY',
                            parameters: {
                                gateway: googlePay.gateway,
                                gatewayMerchantId: googlePay.gatewayMerchantId,
                            },
                        },
                    },
                ],
                merchantInfo: {
                    merchantId: googlePay.merchantId,
                    merchantName: googlePay.merchantName,
                },
                transactionInfo: {
                    totalPriceStatus: 'FINAL',
                    totalPriceLabel: i18n._Labels.Total,
                    totalPrice: props.totalPrice.toFixed(2),
                    currencyCode: 'EUR',
                    countryCode: 'ES',
                },
            }}
            onLoadPaymentData={paymentRequest =>
            {
                props.onPaymentOk(paymentRequest);
            }}
            onCancel={() =>
            {
                navigate('/')
            }}
            onClick={() =>
            {
                if (props.onClick)
                    props.onClick()
            }}
        />
    </div>
    )
}
